<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
   import jsPDF from "jspdf";
   import autoTable from "jspdf-autotable";

   export default {
      page: {
         title: "Earnings Report",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Earnings Report",
            items: [
               {
                  text: "Earnings Report",
                  active: true,
               },                   
            ],

            earnings: [],            
            all_earnings: [],
            
            pagination: {},
            
            from: null,
            to: null,
            total: null,

            keyword: "",
            listing_length: 10,
            from_date: current_date,
            to_date: current_date,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },
      created() {
         this.fetchEarnings();

      },

      methods: {
         clearForm() {
               this.errors = {};  
         },
         fetchEarnings(page_url = null) {

         this.getToken();

         let url = "clinic/earnings_report?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword;         
         
         page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

         this.active_page_url = page_url;
         this.loading = true;
         this.$axios
         .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            var responseData = res.data.data;
            this.earnings = responseData.earnings.data;  
            this.all_earnings = responseData.all_earnings;            
          
            //this.questions = responseData.questions;     
            
            this.pagination = responseData.earnings.links;
            this.from = responseData.earnings.from;
            this.to = responseData.earnings.to;
            this.total = responseData.earnings.total;  
            this.clearForm();
         })
         .catch((error) => {
               if (error.response) {
                  if (error.response.data.message) {
                     if(typeof error.response.data.message === 'object') {
                         this.errors = error.response.data.message;
                        console.log(error.response.status);
                     } else {
                        this.$swal("", error.response.data.message, "error");
                     }                        
                     
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
         })
         .finally(() => (this.loading = false));


         },


         downloadEarningsPdf(){

         let url = "clinic/earnings_report_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword;         
         this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" 
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/pdf" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "earning_report.pdf"; 
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                     console.error("Error downloading PDF file:", error);
                     this.$swal("", "Failed to download PDF file", "error");
               })
               .finally(() => (this.loading = false));

         },

         downloadEarningsExcel() {
            let url = "clinic/earnings_excel_download?limit=" + this.listing_length + "&from_date=" + this.from_date + "&to_date=" + this.to_date + "&keyword=" + this.keyword;         
            this.getToken();
            this.loading = true;
            this.$axios
               .get(url, {
                     headers: { Authorization: "Bearer " + this.token },
                     responseType: "blob" // Specify blob response type
               })
               .then((res) => {
                     const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                     const url = window.URL.createObjectURL(blob);
                     const link = document.createElement("a");
                     link.href = url;
                     link.download = "earning_report.xlsx";
                     link.click();
                     window.URL.revokeObjectURL(url);
               })
               .catch((error) => {
                     // Handle errors
                     console.error("Error downloading Excel file:", error);
                     this.$swal("", "Failed to download Excel file", "error");
               })
               .finally(() => (this.loading = false));
         },

         downloadEarnigsPdfFromClient() {
            if (!this.all_earnings.length) {
               this.$swal("", "No data available to download", "info");
               return;
            }

            const doc = new jsPDF({ orientation: 'landscape' });
            doc.setFontSize(10);
            doc.text("Earnings Report", 14, 15);

            const rows = this.all_earnings.map((earning, index) => {
               const contact = `${earning.country_code || ''} ${earning.mobile || ''}\n${earning.email || ''}`;
               const bookingInfo = `${earning.booking_date} ${earning.start_time} - ${earning.end_time}\n#${earning.id}`;
               return [
                  index + this.from,
                  earning.patient_name,
                  contact,
                  `Dr. ${earning.doctor_name}`,
                  earning.token,
                  bookingInfo,
                  `Rs. ${earning.total_amount}`,
                  earning.converted_created_at
               ];
            });

            autoTable(doc, {
               startY: 20,
               head: [[
                  "Sl No", "Patient", "Contact", "Doctor", "Token", "Booking Info", "Amount", "Created On"
               ]],
               body: rows,
               styles: {
                  fontSize: 7,
                  overflow: 'linebreak',
                  cellPadding: 1,
               },
               headStyles: {
                  fillColor: [41, 128, 185],
                  textColor: 255,
                  halign: 'center',
               },
               columnStyles: {
                  0: { cellWidth: 10 },
                  1: { cellWidth: 25 },
                  2: { cellWidth: 35 },
                  3: { cellWidth: 30 },
                  4: { cellWidth: 12 },
                  5: { cellWidth: 40 },
                  6: { cellWidth: 20 },
                  7: { cellWidth: 30 }
               }
            });

            doc.save("Earnings_Report.pdf");
         },



         getToken() {
         if (localStorage.getItem('medicino_clinic')) {
            var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
            if(medicino_clinic.token) {
               this.token = medicino_clinic.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         }, 
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">

            <div class="card">
               <div class="card-body">
                  <!----- filters area starts---->
                  <div class="row mb-3">
                     <div class="form-group col-lg-4">
                        <label>From Date <span class="text-danger">*</span></label>
                        <b-form-input type="date"  v-model="from_date"  v-bind:class="{ 'is-invalid': Boolean(errors.from_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.from_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     <div class="form-group col-lg-4">
                        <label>To Date <span class="text-danger">*</span></label>
                        <b-form-input type="date"  v-model="to_date" v-bind:class="{ 'is-invalid': Boolean(errors.to_date) }"></b-form-input>
                        <div v-for="(val, index) in errors.to_date" :key="index" class="invalid-feedback">
                           <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                     
                     <!-- <div class="form-group col-lg-4">
                        <label>Fuel Station</label>
                        <select class="form-control">
                           <option value="">All</option>
                           <option value="1">Fuel Station1</option>
                           <option value="2">Fuel Station2</option>
                           <option value="3">Fuel Station3</option>
                        </select>
                     </div> -->
                     
                  </div>
                  <!----- filters area ends---->

                  <div class="row">
                     <div class="col-12">
                        <button class="btn btn-primary me-2" type="button"  @click="fetchEarnings()">View</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadEarnigsPdfFromClient()">Download PDF</button>
                        <button class="btn btn-primary me-2" type="button" @click="downloadEarningsExcel()">Download Excel</button>
                     </div>
                  </div>
               </div>
            </div>
            <div class="card">
               <div class="card-body">
                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchEarnings()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchEarnings()"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th width="8%">Sl No</th>              

                              <th width="15%">Patient</th>              
                              <th width="15%">Contact</th>
                              <th width="15%">Doctor</th>   
                              <th width="5%">Token</th>
                              <th width="20%">Booking Date & Slot & Booking ID</th>
                              <th width="20%">Amount</th>  
                              <th width="15%">Created On</th>
                              <th width="20%">Options</th>
                           </tr>
                          
                        </thead>
                        <tbody v-if="Boolean(earnings.length)">
                           <tr v-for="(earning, index) in earnings" :key="earning.id">
                              <td>{{index + from}}</td>                       
                              <td>{{earning.patient_name}}</td>                       
                              <td>
                                 {{earning.country_code}} {{earning.mobile}}<br>
                                 {{earning.email}}<br>
                              </td>
                              <td>Dr. {{earning.doctor_name}}</td>
                              <td>{{earning.token}}</td>                 
                              <td>{{earning.booking_date|formatDate}}<br>{{earning.start_time|formatTime}} - {{earning.end_time|formatTime}}<br>#{{earning.id}}</td>
                              <td>Rs.{{earning.total_amount}}</td>
                              <td>{{earning.converted_created_at}}</td>
                             
                              <td>
                                 <router-link :to="{ name: 'consultations.details' , params:{id: earning.id} }" class="btn btn-primary me-2 mb-2 btn-sm">Details</router-link>
                                
                                 <!-- <button class="btn btn-warning me-2 mb-2 btn-sm" type="button">Reschedule</button>
                                 <button v-b-modal.cancel-modal class="btn btn-danger me-2 mb-2 btn-sm" type="button">Cancel</button> -->
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="8" class="text-center">No earnings found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption v-if="Boolean(earnings.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchEarnings(page.url + '&limit='+ listing_length + '&from_date=' + from_date + '&to_date=' + to_date  + '&keyword=' + keyword)">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
